<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">{{ currentNews.date }}</p>
    <div class="content">
      <div class="content-section">
        <div class="text-block">
          <p v-html="getSegment(0)"></p>
        </div>
      </div>

      <div class="content-section image-section" v-if="currentNews.other?.picture1?.url || currentNews.other?.picture2?.url">
        <div class="image-grid">
          <div class="image-container" v-if="currentNews.other?.picture1?.url">
            <img :src="currentNews.other.picture1.url" alt="" />
          </div>
          <div class="image-container" v-if="currentNews.other?.picture2?.url">
            <img :src="currentNews.other.picture2.url" alt="" />
          </div>
        </div>
      </div>

      <div class="content-section">
        <div class="text-block">
          <p v-html="getSegment(1)"></p>
        </div>
      </div>

      <div class="content-section">
        <div class="text-block">
          <p v-html="getSegment(2)"></p>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
  
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

// 获取新闻数据的方法
const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  // 通过ID查找新闻
  const newsItem = newsList.find((news: any) => news.id === 'bingliandiankangqi');
  return newsItem || {};
});

const getSegment = (index: number) => {
  const content = currentNews.value.content || '';
  return content.split('---')[index] || '';
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/content-blocks.scss";

.page-container{
  overflow: auto;
}

.content-section {
  margin-bottom: 30px;
}

.text-block {
  p {
    text-align: justify;
    line-height: 1.8;
    margin-bottom: 16px;
  }
}
</style>

